import React, { Component, Suspense } from 'react'
import { HashRouter, Route, Routes } from 'react-router-dom'
import ProtectedRoute from './components/ProtectedRoute'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Restore = React.lazy(() => import('./views/pages/restore/Restore'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))

class App extends Component {
  render() {
    return (
      <HashRouter>
        <Suspense fallback={loading}>
          <Routes>
            <Route element={<ProtectedRoute />}>
              <Route path="*" name="Личный кабинет Пеналбокс" element={<DefaultLayout />} />
            </Route>
            <Route exact path="/login" name="Вход" element={<Login />} />
            <Route exact path="/register" name="Регистрация" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="/restore/:restoreToken" name="Восстановление" element={<Restore />} />
          </Routes>
        </Suspense>
      </HashRouter>
    )
  }
}

export default App
